<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';

  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN
      }
    },
    mounted() {
      this.initRouter();
    }
  }
</script>

<style lang="less">
  @import '~ant-design-vue/dist/antd.less';
  @import './assets/styles/tools.less';
  @import './assets/styles/base.less';
  @import './assets/styles/pace.less';
  @import './assets/styles/form.less';
  @import './assets/styles/result.less';
  @import './assets/styles/btn.less';
  @import './assets/styles/dropdown.less';
  @import './assets/styles/header.less';
  @import './assets/styles/breadcrumb.less';
  @import './assets/styles/spin.less';
  @import './assets/styles/table.less';
  @import './assets/styles/select.less';
  @import './assets/styles/tag.less';
  @import './assets/styles/tree.less';
  @import './assets/styles/drawer.less';
  @import './assets/styles/wangeditor.less';
  @import './assets/styles/upload.less';
  @import './assets/styles/descriptions.less';
  @import './assets/styles/badge.less';
</style>
